import { h } from 'vue'
import { NIcon } from 'naive-ui'

// this method generartes all dynamic page icons
export default icon => {
  return () => h(
    NIcon,
    null,
    {
      default: () => h(icon)
    }
  )
}
